import React, { Component } from 'react'
import { WithStyles, createStyles, Typography, Grid } from '@material-ui/core';

//@ts-ignore
interface OrderNotesProps extends WithStyles<typeof styles> {
    classes: any,
    test: any,
    subject: string,
    goal:any,
    testName: string,
    type: any,
    questionTypes : any
}

interface OrderNotesStates {
    isOpenOrderNotesDialog: boolean,
}

export default class TestDetailsTest extends Component<OrderNotesProps, OrderNotesStates> {
    constructor(props : OrderNotesProps) {
        super(props)
    
        }

    formatSubjectNames = (names: string) => {
        return names.split(',').join(', ')
        
    }

    render() {
        const { classes, test, subject, goal, testName, type,questionTypes } = this.props;
        
        return (
            <div>
                <Grid className={classes.customCard}>
                    {(type === 'question' || type === 'Question') ?
                    <Grid container justify="space-between" alignItems="center">
                        <Grid item >
                            <Typography className={classes.testName}>
                                Question Type: <span>{questionTypes}</span>
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography className={classes.subjectName}>
                                    Subjects: <span> {this.formatSubjectNames(subject)} </span>
                            </Typography>
                        </Grid>
                    </Grid>
                    :
                    <Grid container >
                        <Typography className={classes.testName}>
                            Test Name: <span>{testName}</span>
                        </Typography>
                        <Grid container justify="space-between" alignItems="center">
                        <Grid item>
                            <Typography className={classes.subjectName}>
                                Subjects: <span> {this.formatSubjectNames(subject)} </span>
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography className={classes.subjectName}>
                                Type: <span>{test}</span>
                            </Typography>
                        </Grid>
                    <Grid item xs={3}>
                        <Typography  className={[classes.subjectName, classes.flexDiv].join(' ')}>
                        <img className={classes.image} src="/assets/svg/contentRequest/goal.svg" />
                            Goal:<span className={classes.noWrapGoal}>&nbsp;{goal} </span>
                        </Typography>  
                    </Grid>
                    </Grid>
                    </Grid>}
                </Grid>
            </div>
        )
    }
}
